import PropTypes from 'prop-types';
import { Icon } from '@evertrue/et-components';

/**
 * Step indicator for the bulk message creation wizard.
 * Updated to match PM mockup: Content → Audience & Metrics → Schedule & Launch
 */
const STEPS = [
  { number: 1, label: 'Message Content' },
  { number: 2, label: 'Audience & Metrics' },
  { number: 3, label: 'Schedule & Launch' },
];

const BulkMessageStepIndicator = ({ currentStep, onStepClick }) => {
  return (
    <div className="bulk-message-steps">
      {STEPS.map((step, index) => (
        <div key={step.number} className="bulk-message-steps--item">
          <button
            type="button"
            className={`bulk-message-steps--circle ${
              currentStep > step.number ? 'is-complete' : currentStep === step.number ? 'is-active' : ''
            } is-clickable`}
            onClick={() => onStepClick && onStepClick(step.number)}
          >
            {currentStep > step.number ? <Icon icon="check" /> : step.number}
          </button>
          <span className={`bulk-message-steps--label ${currentStep >= step.number ? 'is-active' : ''}`}>
            {step.label}
          </span>
          {index < STEPS.length - 1 && <div className="bulk-message-steps--line" />}
        </div>
      ))}
    </div>
  );
};

BulkMessageStepIndicator.propTypes = {
  currentStep: PropTypes.number.isRequired,
  onStepClick: PropTypes.func,
};

export default BulkMessageStepIndicator;
